import styled from "styled-components";

const Track = styled.div`
  width: 100%;
  height: 10px;
  background: #DEE0E5;
  border-radius: 999px;
  overflow: hidden;
`;

const Fill = styled.div`
  height: 100%;
  width: ${(p) => p.$pct}%;
  background: #DE644E;
  border-radius: 999px;
  transition: width 180ms ease;
`;

const SubFill = styled.div`
  height: 100%;
  width: ${(p) => p.$pct}%;
  background: #CABDC2;
  border-radius: 999px;
  transition: width 180ms ease;
`;

export function ProgressBar({ value = 0 }) {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <Track aria-label="進捗">
      <Fill $pct={pct} />
    </Track>
  );
}

export function SubProgressBar({ value = 0 }) {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <Track aria-label="進捗">
      <SubFill $pct={pct} />
    </Track>
  );
}